import type { ChatbotRateLimit } from '@/models/chatbot';
import { WARNING_THRESHOLD, CRITICAL_THRESHOLD } from './rateLimit.constants';

export type RateLimitSeverity = 'normal' | 'warning' | 'critical' | 'exhausted';

export const getRateLimitSeverity = (remaining: number): RateLimitSeverity => {
  if (remaining <= 0) return 'exhausted';
  if (remaining < CRITICAL_THRESHOLD) return 'critical';
  if (remaining <= WARNING_THRESHOLD) return 'warning';
  return 'normal';
};

export const formatTimeRemaining = (resetAtEpochSeconds: number): string | null => {
  const nowMs = Date.now();
  const resetMs = resetAtEpochSeconds * 1000;
  const diffMs = resetMs - nowMs;

  if (diffMs <= 0) return null;

  const diffMinutes = Math.round(diffMs / 60_000);

  if (diffMinutes < 1) return '1m';
  if (diffMinutes < 60) return `${diffMinutes}m`;

  const diffHours = Math.floor(diffMs / 3_600_000);
  return `${diffHours}h`;
};

export const normalizeRateLimit = (rateLimit: ChatbotRateLimit): ChatbotRateLimit => {
  if (rateLimit.remaining !== 0 || rateLimit.limit === null || rateLimit.resetAt === null) {
    return rateLimit;
  }

  if (formatTimeRemaining(rateLimit.resetAt) !== null) {
    return rateLimit;
  }

  return {
    remaining: rateLimit.limit,
    limit: rateLimit.limit,
    resetAt: null,
  };
};
